<template>
    <v-row class="mx-2 d-flex justify-center custom-border white">
        <v-col class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-12">
            <h4 class="mb-1">{{GetPropertyInfo() !== null && GetPropertyInfo() !== undefined ? GetPropertyInfo().name :
            ''}}</h4>
            <div v-if="GetPropertyInfo() !== null && GetPropertyInfo() !== undefined">
                <p v-html=" GetPropertyInfo().description"></p>
            </div>
            <div class="my-1">
                <v-icon class="black--text darken-2">mdi-home</v-icon>
                {{GetPropertyInfo() !== null && GetPropertyInfo() !== undefined ? GetPropertyInfo().address : ''}}
            </div>
            <div class="my-1">
                <v-icon class="black--text darken-2">mdi-phone</v-icon>
                {{GetPropertyInfo() !== null && GetPropertyInfo() !== undefined ? GetPropertyInfo().primaryPhone : ''}}
            </div>
            <div class="my-1">
                <v-icon class="black--text darken-2">mdi-email</v-icon>
                {{GetPropertyInfo() !== null && GetPropertyInfo() !== undefined ? GetPropertyInfo().primaryEmail : ''}}
            </div>


            <div class="my-1" v-if="GetPropertyInfo() !== null 
            && GetPropertyInfo() !== undefined 
            && GetPropertyInfo().facebookLink">
                <v-icon @click="goToSocialMedia(GetPropertyInfo().facebookLink)" class="black--text darken-2">mdi-facebook
                </v-icon>
                &nbsp;
                <a style="text-decoration: none" :href="GetPropertyInfo() !== null && GetPropertyInfo() !== undefined ? GetPropertyInfo().facebookLink : ''">facebook</a>

            </div>

            <div class="my-1" v-if="GetPropertyInfo() !== null && GetPropertyInfo() !== undefined && GetPropertyInfo().instagramLink"
                >
                <v-icon @click="goToSocialMedia(GetPropertyInfo().instagramLink)" class="black--text darken-2">mdi-instagram</v-icon>
                &nbsp;
                <a style="text-decoration: none" :href="GetPropertyInfo() !== null && GetPropertyInfo() !== undefined ? GetPropertyInfo().instagramLink : ''">instagram</a>
            </div>
            <div class="my-1" v-if="GetPropertyInfo() !== null && GetPropertyInfo() !== undefined && GetPropertyInfo().youtubeLink">
                <v-icon @click="goToSocialMedia(GetPropertyInfo().youtubeLink)" class="black--text darken-2">mdi-youtube</v-icon> &nbsp;
                <a style="text-decoration: none" :href="GetPropertyInfo() !== null && GetPropertyInfo() !== undefined ? GetPropertyInfo().youtubeLink : ''">youtube</a>

            </div>
        </v-col>

        <!-- <v-col class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-12 d-flex justify-center my-0 py-0">
            <v-btn link class="mx-4 blue--text" icon>
                <v-icon size="24px">
                    mdi-facebook
                </v-icon>
            </v-btn>
            <v-btn
                 key="mdi-instagram" class="mx-4 orange--text"
                icon>
                <v-icon size="24px">
                    mdi-instagram
                </v-icon>
            </v-btn>
            <v-btn  key="mdi-youtube" class="mx-4 red--text" icon>
                <v-icon size="24px">
                    mdi-youtube
                </v-icon>
            </v-btn>


        </v-col> -->

        <v-col class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-12">
            <h3 class="mb-1">Location</h3>
            <div v-if="GetPropertyInfo() !== null && GetPropertyInfo() !== undefined">
                <v-img max-height="150" max-width="250" @click="goToMap" :src="GetPropertyInfo().mapUrl"></v-img>
            </div>
        </v-col>


    </v-row>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    data() {
        return {

        }
    },
    computed: {
        ...mapGetters([
            'GetBookingPolicy',
            'GetPropertyInfo',
            'GetPropertyFacilitiesAndServices']),
    },
    methods: {
        goToMap: function () {
            window.open(this.GetPropertyInfo().mapLocation, '_blank').focus();
        },
        goToSocialMedia: function (data) {
            window.open(data, '_blank').focus();
        }
    }
}
</script>